export default __webpack_public_path__ + "static/media/node_express.4f6e3a7b.png";